// client/src/modules/technician/nav.ts
import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Today', path: '/technician' },
  { label: 'History', path: '/technician/history' },
  { label: 'Generators', path: '/technician/generators' },
  // Tips Review — hidden until there's content to review (kept routed for direct URL access)
  // { label: 'Tips Review', path: '/technician/curation', requireManagerOrAdmin: true },
];
